import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { isUndefined } from 'lodash';

import EventStatusIndicator from 'components/events/EventStatusIndicator';

import { useEvent } from 'components/context/EventContext';
import { getDaysUntilLock } from 'services/events/helpers';

import useStyles from './style';

const Status: FC = () => {
  const classes = useStyles();

  const { event, isHistory, isEventLocked } = useEvent();

  const daysBeforeLockout = useMemo(
    () =>
      event?.date &&
      !isUndefined(event?.daysCountBeforeLock) &&
      getDaysUntilLock(event.date, event?.daysCountBeforeLock),
    [event?.date, event?.daysCountBeforeLock]
  );

  return isHistory ? null : (
    <div className={classNames('status', classes.status)} data-hash="statusinput">
      <EventStatusIndicator event={(event as unknown) as EventItem} />
      {!!event?.daysCountBeforeLock && !isEventLocked && !!event?.date ? (
        <span>{`Will be locked in ${daysBeforeLockout} days`}</span>
      ) : null}
    </div>
  );
};

export default Status;
